"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WALKTHROUGH_PICTURE_COPY = exports.WALKTHROUGH_NEXT_STEP_LABEL_COPY = exports.WALKTHROUGH_PREVIOUS_STEP_LABEL_COPY = exports.WALKTHROUGH_PAGE_NAME_COPY = exports.WALKTHROUGH_CLOSE_LABEL_COPY = exports.WALKTHROUGH_EXAMPLE_COPY = exports.WALKTHROUGH_SPLASH_PAGE_COPY = exports.WALKTHROUGH_THIS_PAGE_COPY = exports.WALKTHROUGH_NEXT_COPY = exports.WALKTHROUGH_BACK_COPY = exports.WALKTHROUGH_NAV_COPY = exports.WALKTHROUGH_SEE_HOW_COPY = exports.WALKTHROUGH_NAME_COPY = exports.WALKTHROUGH_STEPS_COPY = exports.WALKTHROUGH_STEP_COUNT = void 0;
exports.walkthroughHeaderCopy = walkthroughHeaderCopy;
exports.walkthroughContinueCopy = walkthroughContinueCopy;
exports.walkthroughBackToCopy = walkthroughBackToCopy;
exports.walkthroughDoneCopy = walkthroughDoneCopy;
exports.WALKTHROUGH_STEP_COUNT = 10;
exports.WALKTHROUGH_STEPS_COPY = [
    {
        tag: "Getting started",
        title: "Connect your bank",
        body: "Link the checking account your paychecks land in. Fomo-Fi finds your income on its own.",
    },
    {
        tag: "Getting started",
        title: "We review 12 months",
        body: "Fomo-Fi learns your paydays, your bills, what you usually spend and the debts you pay.",
    },
    {
        tag: "Plan",
        title: "Confirm your income",
        body: "Check each paycheck we found so every suggestion starts from the right number.",
    },
    {
        tag: "Plan",
        title: "See your remaining balance",
        body: "Your bank balance minus the bills due before each payday shows your remaining balance to assign to budgets.",
    },
    {
        tag: "Plan",
        title: "Create your buckets",
        body: "Plan where your remaining balance goes before payday. Split it into buckets for each type of spending: groceries, gas and transportation, emergency, savings and a guilt-free Splash Fund.",
    },
    {
        tag: "Plan · Debt Eliminator",
        title: "Get out of debt with Debt Eliminator",
        body: "Your 12-month analysis finds every card and loan you pay. Debt Eliminator builds a payoff plan around what you can afford each payday, highest rate first, and shows your debt-free date.",
    },
    {
        tag: "Plan",
        title: "A 2-minute payday check-in",
        body: "Confirm the paycheck, carry over what you didn't spend and give leftovers a home.",
    },
    {
        tag: "Home",
        title: "Check what you can spend",
        body: "A 10-second look every day. Purchases land in the right bucket on their own.",
    },
    {
        tag: "Upcoming",
        title: "See what's coming",
        body: "Every bill and paycheck before it hits. The one place to edit them.",
    },
    {
        tag: "Insights",
        title: "How am I doing?",
        body: "A monthly look at your plan against what really happened.",
    },
];
/** The overlay's name, also its accessible title. */
exports.WALKTHROUGH_NAME_COPY = "How Fomo-Fi works";
/** Header: "How Fomo-Fi works · 5 of 10". Real text, not only the bar (H8). */
function walkthroughHeaderCopy(step) {
    return `${exports.WALKTHROUGH_NAME_COPY} · ${step} of ${exports.WALKTHROUGH_STEP_COUNT}`;
}
/** The link on the splash hero and every sign-up page. */
exports.WALKTHROUGH_SEE_HOW_COPY = "See how it works · 1 min";
/** After closing partway: "Continue how it works (step 5 of 10)". */
function walkthroughContinueCopy(step) {
    return `Continue how it works (step ${step} of ${exports.WALKTHROUGH_STEP_COUNT})`;
}
/** The splash page's top-nav item. */
exports.WALKTHROUGH_NAV_COPY = "How it works";
exports.WALKTHROUGH_BACK_COPY = "Back";
exports.WALKTHROUGH_NEXT_COPY = "Next";
/** What "Back to [page]" names when the page it was opened over has no name of its own
 *  (web's walkthroughBridge fallback, now shared). */
exports.WALKTHROUGH_THIS_PAGE_COPY = "this page";
/** "Back to Connect bank". `page` is the page the walkthrough was opened over. Over the
 *  splash page it's "the home page" (Part 4 #5: the screenshot's version). */
function walkthroughBackToCopy(page) {
    return `Back to ${page}`;
}
/** Step 10's Next: "Done · back to Connect bank". */
function walkthroughDoneCopy(page) {
    return `Done · back to ${page}`;
}
/** What the splash page is called inside "Back to [page]" (Part 4 #5). */
exports.WALKTHROUGH_SPLASH_PAGE_COPY = "the home page";
/** @deprecated No longer drawn: Anthony's pictures have no "Example" label (Paul, N8,
 *  2026-10-29). Kept until mobile stops reading it, then deleted. */
exports.WALKTHROUGH_EXAMPLE_COPY = "Example";
/** An icon-only close (×) elsewhere, e.g. Plan's first-visit card. The walkthrough's own
 *  × is named like its "Back to [page]" button (addendum R5): walkthroughBackToCopy. */
exports.WALKTHROUGH_CLOSE_LABEL_COPY = "Close";
/**
 * Addendum R5 (Anthony's prototype, `where`): what "Back to [page]" calls each page the
 * walkthrough opens over; the × button's label is the same text. Pages not listed (Home,
 * Help, Upcoming...) keep their nav name, and "this page" when they have none.
 */
exports.WALKTHROUGH_PAGE_NAME_COPY = {
    splash: { name: exports.WALKTHROUGH_SPLASH_PAGE_COPY },
    account: { name: "Create account" },
    payment: { name: "your free trial" },
    bank: { name: "Connect bank" },
    analysis: { name: "your analysis" },
    plan: { name: "Plan" },
};
/** §8, the phone header's arrows (How It Works phone canvas). */
exports.WALKTHROUGH_PREVIOUS_STEP_LABEL_COPY = "Previous step";
exports.WALKTHROUGH_NEXT_STEP_LABEL_COPY = "Next step";
/**
 * The words in the example pictures beside all ten steps (E4, E15; addendum R3), word for
 * word from Anthony's prototype (Sign-up Screens, Prototype p0-p9). Sample figures, with
 * no "Example" label: his design has none (Paul, N8, 2026-10-29). Keys are
 * `label`/`text`/`name`/`detail` so the copy inventory reads them. Bar lengths and colours are drawing, not words, so each app keeps them.
 */
exports.WALKTHROUGH_PICTURE_COPY = {
    /** @deprecated Not drawn (N8); kept until mobile stops reading it, then deleted. */
    example: { label: exports.WALKTHROUGH_EXAMPLE_COPY },
    /** Step 1, "Connect your bank". */
    connectBank: {
        search: { text: "Search for your bank" },
        account: { name: "Checking ••4821", detail: "Connected" },
    },
    /** Step 2, "We review 12 months". */
    analysis: {
        progress: { name: "12 months reviewed", detail: "100%" },
        rows: [
            { name: "Paychecks", detail: "Found" },
            { name: "Repeating bills", detail: "Found" },
            { name: "Everyday spending", detail: "Averaged" },
        ],
    },
    /** Step 3, "Confirm your income". */
    income: {
        paycheck: {
            label: "Paycheck we found",
            text: "$3,800",
            detail: "Every other Monday · next Oct 26",
        },
        confirm: { label: "Looks right" },
        edit: { label: "Edit" },
    },
    /** Step 4, "See your remaining balance". */
    remaining: {
        rows: [
            { name: "Balance", detail: "$5,612" },
            { name: "Bills", detail: "−$368" },
            { name: "Remaining", detail: "$5,244" },
        ],
    },
    /** Step 5, "Create your buckets". */
    buckets: {
        remaining: { text: "Your remaining balance: $5,244 until payday" },
        rows: [
            { name: "Groceries", detail: "$284" },
            { name: "Gas / Transportation", detail: "$86" },
            { name: "Emergency fund", detail: "$250" },
            { name: "Savings", detail: "You choose" },
            { name: "Splash Fund", detail: "$512" },
        ],
    },
    /** Step 6, "Get out of debt with Debt Eliminator". */
    debt: {
        found: { text: "Found in your analysis: 2 cards · 2 loans · $28,060" },
        rows: [
            { name: "Store card · 29.9%", detail: "Paying first" },
            { name: "Rewards card", detail: "Next" },
        ],
        plan: { text: "Extra $300 each payday · debt-free by May 2027" },
    },
    /** Step 7, "A 2-minute payday check-in". */
    checkin: {
        title: { text: "Payday check-in · 2 minutes" },
        paycheck: { name: "+$3,800", detail: "As expected" },
        leftovers: { text: "Carry over $81 · park $94 in Emergency fund" },
    },
    /** Step 8, "Check what you can spend". */
    home: {
        safe: { label: "Safe to spend until payday", text: "$335" },
        bucket: { name: "Groceries", detail: "$152 left" },
    },
    /** Step 9, "See what's coming". */
    upcoming: {
        rows: [
            { name: "Oct 23 · Electric", detail: "−$96" },
            { name: "Oct 24 · Car insurance", detail: "−$207" },
            { name: "Oct 25 · Phone", detail: "−$65" },
            { name: "Oct 26 · Paycheck", detail: "+$3,800" },
        ],
    },
    /** Step 10, "How am I doing?". */
    insights: {
        title: { text: "September · plan vs. actual" },
        rows: [
            { name: "Groceries", detail: "$540 of $568" },
            { name: "Splash Fund", detail: "$1,090 of $1,024" },
            { name: "Transportation", detail: "$150 of $172" },
        ],
    },
};
//# sourceMappingURL=walkthroughCopy.js.map